<script lang="ts">
export default {
	name: "ChartLegend",
};
</script>

<script setup lang="ts">
import { useModelValue } from "@soft-db/soft-utils";
import type { CartesianSerieWithValue } from "../../interfaces";
import LegendItem from "./LegendItem.vue";

const props = withDefaults(
	defineProps<{
		series?: CartesianSerieWithValue[];
		showValue?: boolean;
		right?: boolean;
		activeSerie?: string;
	}>(),
	{
		series: () => [],
	}
);

const activeSerieSync = useModelValue(props, "activeSerie");
const onLegendClick = (id: string) => {
	if (activeSerieSync.value === id) {
		activeSerieSync.value = "";
	} else {
		activeSerieSync.value = id;
	}
};
</script>

<template>
	<div class="relative truncate whitespace-nowrap" :class="!right ? 'px-2' : ''">
		<LegendItem
			v-for="serie of series"
			:key="serie.id"
			:class="right ? 'legend--right' : ''"
			:serie="serie"
			:showValue="showValue"
			:selected="activeSerieSync === serie.id"
			@click="() => onLegendClick(serie.id)"
		>
			<template v-if="$slots['item:label']" #label="slotProps">
				<slot name="item:label" v-bind="slotProps" />
			</template>

			<template v-if="$slots['item:value']" #value="slotProps">
				<slot name="item:value" v-bind="slotProps" />
			</template>
		</LegendItem>
	</div>
</template>
